import { defineMessages } from 'react-intl';

export default defineMessages({
  blockedContentMessage: {
    id: 'blockedContentMessage',
    defaultMessage:
      'The content will be blocked as the domain is not allowed. Request to add a domain.',
  },
  alertContentMessage: {
    id: 'alertContentMessage',
    defaultMessage:
      'Content will not be displayed to users who refuse cookies.',
  },
});
